module.exports = __webpack_public_path__ + "img/extended.47d73ef7.png";